<script setup lang="ts">
import { onKeyDown } from '@vueuse/core'

const emit = defineEmits<{ close: [] }>()

const props = defineProps<{
  homePlayerName: string
  visitorPlayerName: string
  homeScore: number
  visitorScore: number
  onConfirm: () => void
  onCancel: () => void
}>()

function confirm() {
  props.onConfirm()
  emit('close')
}

function cancel() {
  props.onCancel()
  emit('close')
}

onKeyDown('Enter', (e) => {
  e.stopPropagation()
  e.preventDefault()
  confirm()
})

onKeyDown('Backspace', () => {
  cancel()
})
</script>

<template>
  <UiAlertDialog :open="true">
    <UiAlertDialogContent @escape-key-down="cancel">
      <UiAlertDialogTitle class="text-4xl">
        {{ $t('Game finished') }}
      </UiAlertDialogTitle>
      <div class="text-4xl mb-6">
        {{
          $t('Please confirm that {winnerName} won the game', {
            winnerName: props.homeScore > props.visitorScore ? props.homePlayerName : props.visitorPlayerName,
          })
        }}
      </div>
      <div class="mb-6 flex flex-row items-center gap-2">
        {{ homePlayerName }} <UiBadge :variant="props.homeScore > props.visitorScore ? 'success' : 'destructive'">
          {{ props.homeScore }}
        </UiBadge> - <UiBadge :variant="props.homeScore > props.visitorScore ? 'destructive' : 'success'">
          {{ props.visitorScore }}
        </UiBadge> {{ visitorPlayerName }}
      </div>
      <UiAlertDialogFooter class="justify-between">
        <UiButton
          variant="success"
          size="huge"
          @click="confirm"
        >
          {{ $t('Confirm') }}
        </UiButton>
        <UiButton
          variant="destructive"
          size="huge"
          @click="cancel"
        >
          {{ $t('Cancel') }}
        </UiButton>
      </UiAlertDialogFooter>
    </UiAlertDialogContent>
  </UiAlertDialog>
</template>
